var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"Sidebar menu"},[_c('transition',{attrs:{"name":"slide"}},[(_vm.isPanelOpened)?_c('div',{staticClass:"sidebar-panel"},[_vm._t("default"),_c('LocaleSwitcher')],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }